import { useActivityDockStore } from './dock-store'

/**
 * Tell the dock that work may have started or changed, so it asks now instead of at its next
 * poll. A module calls it after it starts something long (the Email Remediator needs not: the dock
 * also listens for its query invalidations, see the renderer's `refreshKeys`). Safe anywhere,
 * including on the server (does nothing there).
 */
export const ACTIVITIES_CHANGED_EVENT = 'hf:activities:changed'

export function notifyActivitiesChanged(): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new Event(ACTIVITIES_CHANGED_EVENT))
}

/** Open the dock's drawer, on one activity if you name it (its `id` from GET /activities). */
export function openActivityDock(activityId?: string): void {
  useActivityDockStore.getState().openDock(activityId)
}
